module.exports = __webpack_public_path__ + "img/step-2.8f600596.jpg";